import { render, staticRenderFns } from "./TerrainFormPreview.vue?vue&type=template&id=96c23418&scoped=true"
import script from "./TerrainFormPreview.vue?vue&type=script&lang=js"
export * from "./TerrainFormPreview.vue?vue&type=script&lang=js"
import style0 from "./TerrainFormPreview.vue?vue&type=style&index=0&id=96c23418&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c23418",
  null
  
)

export default component.exports